module.exports = __webpack_public_path__ + "img/mail-icon.898fb8d0.svg";